export default "__VITE_ASSET__a50f2660__"